import React from "react";
import {default as axios} from "axios";
import "./Snippet.scss";
import domain from "../../util/domain";

function Snippet ({snippet, getSnippets, editSnippet}) {

    async function deleteSnippet() {
        if (window.confirm("Do you want to delete this snippet?")) {
            await axios.delete(domain + "/snippet/" + snippet._id);
            getSnippets();
        }
    }

    return (
        <div className="snippet">
           {snippet.PCP && <p className="pcp">PCP: {snippet.PCP}</p>}
            {snippet.roomNumber && <p className="roomNumber">Room Number:{snippet.roomNumber}</p>}
            {snippet.lastName &&  (
                <pre className="names">
                <p>Last Name:{snippet.lastName}</p>
                </pre>)}
            {snippet.firstName &&  (
                <pre className="names">
                <p>First Name:{snippet.firstName}</p>
                </pre>)}
            <button className="btn-edit" onClick={() => editSnippet(snippet)}>Edit</button>
            <button className="btn-delete" onClick={deleteSnippet}>Delete</button>
    </div>
    );
}

export default Snippet;